<template>
  <el-dialog width="1200px" title="Status Track" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <div>
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @submit.native.prevent="getDataList(1)">
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchStartToEndSecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Start Date"
            end-placeholder="Ending Date"
            @change="getDataList(1)"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="mt20 tableWrap">
      <el-table border :data="dataList" v-loading="dataListLoading">
        <el-table-column align="center" label="Handling Time" width="164px">
          <template slot-scope="scope">
            {{ scope.row.createAt | parseTimeSecond }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="Handler">
          <template slot-scope="scope">
            <p>
              {{ scope.row.userInfo.nickname }}
              <span>({{ scope.row.type }})</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Applyment Status">
          <template slot-scope="scope">
            <p>{{ applymentStatusFormat(scope.row.applymentStatus) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" label="Remark" />
        <el-table-column prop="attachmentUrls" align="center" label="Attachment">
          <template slot-scope="scope">
            <p v-for="item in scope.row.attachmentUrls" :key="item.url">
              <a :href="item.url" target="_target">{{ item.name }}</a>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import searchMixin from "@/mixins/searchMixin";
import filtersMixin from "@/mixins/filtersMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [paginationMixin, searchMixin, filtersMixin, formatterMixin],
  components: { Pagination },
  props: {
    applymentId: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataForm: {
        startTime: "",
        endTime: "",
      },
      watchStartToEndSecondTimeRange: null,
    };
  },
  methods: {
    // 初始化
    async init() {
      this.visible = true;
      await this.$nextTick();
      this.dataForm = {
        startTime: "",
        endTime: "",
      };
      this.getDataList(1);
    },
    // 获取分页
    getDataList(current) {
      setTimeout(async () => {
        this.dataListLoading = true;
        if (current) {
          this.current = current;
        }
        const { code, data } = await this.$http.get("/admin/companyApplymentLog/paging", {
          params: {
            current: this.current,
            size: this.pageSize,
            "orders[0].asc": false,
            "orders[0].column": "id",
            applymentId: this.applymentId,
            startTime: this.dataForm.startTime,
            endTime: this.dataForm.endTime,
          },
        });
        if (code === 200) {
          this.dataList = data.records;
          this.totalCount = data.total;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.tableWrap {
  padding-bottom: 20px;
}
</style>
